module.exports = __webpack_public_path__ + "common/icon-link-4a221a4baa07a3a3e6948752b79d102e.svg";